import { formatDuration, intervalToDuration } from 'date-fns';

interface DurationLongProps {
  start: Date;
  end: Date;
}

/**
 * Formats a duration in a long format, e.g. "1 month, 2 days, 3 hours, 4 minutes"
 */
export function DurationLong({ start, end }: DurationLongProps) {
  const duration = intervalToDuration({ start, end });
  const formattedDuration = formatDuration(duration, {
    format: ['months', 'days', 'hours', 'minutes'],
    delimiter: ', ',
  });
  return <span className="tabular-nums">{formattedDuration}</span>;
}
